import { clearAllLabel } from './FilesHubFilterPillContainer.locstring.json';
import loc from 'owa-localize';
import { observer as observerLite } from 'mobx-react-lite';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';

import * as React from 'react';

const styles = require('./FileshubFilterPill.scss');
const classNames = require('classnames');

export interface Pill {
    text: string;
    onRemove: () => void;
}
interface FilesHubFilterPillContainerProps {
    pills: Pill[];
    /**
     * Called after an individual pill is removed, or when "clear all" is clicked.
     * This can be used to update other UI elements instead of the pills onRemove to avoid having
     * the many calls to onRemove made when "clear all" is clicked
     * */
    onAfterRemove: () => void;
}

@observer
export class FilesHubFilterPillContainer extends React.Component<
    FilesHubFilterPillContainerProps,
    {}
> {
    render() {
        const { pills, onAfterRemove } = this.props;

        const pillElements = pills.map<JSX.Element>(pill => (
            <FilesHubFilterPill key={pill.text} pill={pill} onAfterRemove={onAfterRemove} />
        ));

        if (pillElements.length > 1) {
            pillElements.push(this.createClearAllFilterPill());
        }

        return <div className={styles.pillsContainer}>{pillElements}</div>;
    }

    private createClearAllFilterPill = () => {
        return (
            <div
                className={classNames(styles.filterPillContainer, styles.cleartext)}
                onClick={this.onClick}>
                {loc(clearAllLabel)}
            </div>
        );
    };

    private onClick = () => {
        this.props.pills.forEach(pill => pill.onRemove());
        this.props.onAfterRemove();
    };
}

interface FilesHubFilterPillProps {
    pill: Pill;
    onAfterRemove: () => void;
}

const FilesHubFilterPill = observerLite(function FilesHubFilterPill(
    props: FilesHubFilterPillProps
) {
    const { pill, onAfterRemove } = props;
    const onClickCallback = React.useCallback(() => {
        pill.onRemove();
        onAfterRemove();
    }, [props.pill]);
    return (
        <div
            className={classNames(styles.filterPillContainer, styles.hoverEffect)}
            onClick={onClickCallback}>
            <div className={styles.text}>{pill.text}</div>
            <Icon className={styles.removeFilterIcon} iconName={ControlIcons.Cancel} />
        </div>
    );
});
